//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- EXPORTAÇÃO DO SERVIÇO LOAD COMPANIES ---------------//
// Responsável por requisitar à API as empresas existentes ao usuário
export default async function desynchronizeProductsService(groupId, productId) {
    try {
        await api.delete(`/grupos-produtos/${groupId}/produtos/${productId}`);
        toast.success("Produto removido do grupo com sucesso");
        return true;
    } catch (error) {
        toast.error("Erro ao remover produto do grupo");
        return false;
    }
}